/**
 * Recurrence-Editor component exported items
 */
export * from './recurrence-editor';



//////////////////
// WEBPACK FOOTER
// ./node_modules/@syncfusion/ej2-schedule/src/recurrence-editor/index.js
// module id = 1967
// module chunks = 0